import {Component} from '@angular/core';
import {BasePatientPage} from "../../base-patient-page";
import {FormsModule} from "@angular/forms";
import {MatProgressBar} from "@angular/material/progress-bar";
import {IntakeStatusPillComponent} from "../../../../components/pills/intake-status-pill";
import {AppointmentStatus, IntakeStatus} from "intake-shared";
import {OrgDatePipe} from "@allaihealth/ng-platform";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {SurveyQuestions} from "@allaihealth/survey";

/** The overview of a patient and their appointment details */
@Component({
	selector: 'app-overview',
	templateUrl: './overview.component.html',
	standalone: true,
	imports: [
		FormsModule,
		MatProgressBar,
		IntakeStatusPillComponent,
		OrgDatePipe,
		MatCheckboxModule
	],
	styleUrl: './overview.component.scss'
})
export class OverviewComponent extends BasePatientPage {
	progressAmount:number = 0;

	getStatus(category:string) {
		if(category === "payment" && this.patientInfo.data[SurveyQuestions.InsuranceStatus] == "SELF_PAY") {
			if(this.tasks.status == AppointmentStatus.CheckedOut) {
				return IntakeStatus.CompleteCheckedOut;
			}
			return IntakeStatus.Complete;
		}

		const tasks = Object.entries(this.taskValues).filter(([key, _value]) => key.startsWith(`${category}.`));
		const trues = tasks.filter(([_key, value]) => value).length;

		if(tasks.length == trues) {
			if(this.tasks.status == AppointmentStatus.CheckedOut) {
				return IntakeStatus.CompleteCheckedOut;
			}
			return IntakeStatus.Complete;
		}

		if(trues > 0) {
			return IntakeStatus.InProgress;
		}
		if(this.tasks.status != AppointmentStatus.Scheduled) {
			return IntakeStatus.NotStartedWarning;
		}
		return IntakeStatus.NotStarted;
	}

	override ngOnInit() {
		super.ngOnInit();
		this.calculateProgress();
	}

	calculateProgress() {
		const tasks = Object.entries(this.taskValues).length;
		const trues = Object.values(this.taskValues).filter(v => v).length;
		this.progressAmount = Math.round((trues / tasks) * 100);
	}

	override async setValue(taskKey:string, valueKey:string, $event:boolean) {
		await super.setValue(taskKey, valueKey, $event);
		this.calculateProgress();
	}

	protected readonly SurveyQuestions = SurveyQuestions;
}
